import { createPlugin } from './pm-plugins/main';
export var codeBidiWarningPlugin = function codeBidiWarningPlugin(_ref) {
  var config = _ref.config;
  return {
    name: 'codeBidiWarning',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'codeBidiWarning',
        plugin: function plugin(options) {
          return createPlugin(options, config !== null && config !== void 0 ? config : {});
        }
      }];
    }
  };
};